import { render, staticRenderFns } from "./ProjectTaskPanel.vue?vue&type=template&id=60307512&"
import script from "./ProjectTaskPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports